import { Token } from "src/domains/user/types";
import { apiBaseUrls } from "src/platform/constants/shared-constants";
import API, { IApiError } from "src/platform/http/shared-http";

const TOKENS = "/api/v1/tokens";

class ApiService {
  public static async getTokens(type: string): Promise<Token[] | IApiError> {
    const api = new API(apiBaseUrls.BACKEND, `${TOKENS}?type=${type}`);
    const response = await api.get<Token[]>();
    if ("error" in response && "status" in response) {
      return response as IApiError;
    }
    return response;
  }

  public static async createToken(token: Token): Promise<Token | IApiError> {
    const api = new API(apiBaseUrls.BACKEND, TOKENS);
    const response = await api.post<Token>(token);
    if ("error" in response && "status" in response) {
      return response as IApiError;
    }
    return response;
  }

  public static async deleteToken(alias: string): Promise<void> {
    const api = new API(apiBaseUrls.BACKEND, `${TOKENS}/${alias}`);
    await api.delete();
  }
}

export default ApiService;
